module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/core-js/library/modules/_add-to-unscopables.js
// module id = ../../../../core-js/library/modules/_add-to-unscopables.js
// module chunks = 3